<template>
  <div
    aria-controls="billing-collapse"
    data-bs-target="#billing-collapse"
    aria-expanded="false"
    class="resource-header accordion-toggle align-items-center"
    data-bs-toggle="collapse"
  >
    <div class="mb-24 d-flex align-items-center">
      <v-button class="btn-icon w-fit" size="sm" variant="primary">
        <v-icon icon="bookmark" size="sm" space="me-8" />
        {{ $t("general.shared.billing") }}
      </v-button>
    </div>
    <v-icon class="accordion-icon" icon="chevron-up" size="xl" />
  </div>
  <div id="billing-collapse" class="billing-section accordion-body collapse show p-24 w-100">
    <div class="d-flex justify-content-end p-3 gap-8">
      <v-button
        class="btn-icon w-fit align-self-center"
        :class="invoiceAmount?.custom_notes !== undefined && invoiceAmount?.custom_notes !== null  ? 'cutom-notes' : ''"
        size="sm"
        variant="primary"
        @click="openCustomNotesModal"
      >
        <v-icon icon="comment" size="sm" />
      </v-button>
      <v-button class="btn-icon w-fit" size="sm" variant="primary" @click="openBillingOffCanvas">
        <v-icon icon="plus" size="sm" space="me-8" />
        {{ $t("tourPricing.newInvoice") }}
      </v-button>
    </div>
    <div class="row align-items-center pt-24 w-100">
      <div class="col-2">
        <p class="mb-0">Total Program</p>
      </div>
      <div class="col-8 d-flex justify-content-end total-price-container">
        <v-pricing-update
          :id="`tour-${tourId}`"
          :gross="gross"
          :markup="markup"
          :net="net"
          :agency="agency"
          :case-id="Number(caseId)"
          :tour-id="Number(tourId)"
          class="is-mobile"
          is-total
          is-invoice
          is-new-version
          @update-total-pricing="onUpdateTotalPricing"
          @load-tour-pricing="onLoadTourPricing"
        />
      </div>
      <div class="col-2 quote-container d-flex align-items-center">
        <v-form-input
          autocomplete="off"
          form-type="input-group"
          id="quote-price"
          v-model="localQuotePrice"
          onwheel="return false;"
          right-addon="€"
          step=".01"
          type="number"
          :disabled="lock"
          @blur="emitUpdateQuotePrice('input')"
        />
        <div class="ms-2 lock-btn">
          <v-button
            class="btn btn-primary p-4"
            variant="icon"
            @click="
              toggleLock();
              emitUpdateQuotePrice('button');
            "
          >
            <TheLock v-if="lock" />
            <TheUnLock v-else />
          </v-button>
        </div>
      </div>
    </div>
    <div
      class="row align-items-center pt-12 w-100"
      v-for="item in invoiceListData.filter((e) => e.type === 'emitted')"
      :key="item.id"
    >
      <template v-for="subItem in item.invoice_lines" :key="subItem.id">
        <!-- Invoice Field -->
        <div class="col-2">
          <div class="button-container">
            <span class="button-label">{{ $t("general.shared.invoice") }}</span>
            <button class="custom-button" :id="`invoice-${subItem.id}`" @click="navigateToInvoicePage(item.id)">
              <v-icon icon="pdf" size="sm" space="p-12" />
              {{ item.number }}
            </button>
          </div>
        </div>

        <!-- Concept Field -->
        <div class="col-8 d-flex justify-content-end total-price-container">
          <v-form-input
            :id="`concept-${subItem.id}`"
            class="w-100 disabled-input"
            :label="$t('general.shared.concept')"
            autocomplete="off"
            form-type="outline"
            type="text"
            input-type="textarea"
            disabled
            v-model="subItem.description"
          />
        </div>

        <!-- Amount Field -->
        <div class="col-2 quote-container d-flex align-items-center">
          <v-form-input
            :id="`amount-${subItem.id}`"
            :label="$t('general.shared.amount')"
            autocomplete="off"
            form-type="outline"
            type="text"
            disabled
            class="disabled-input"
            v-model="item.amount"
          />
        </div>
      </template>
    </div>
    <!-- Remaining Amount -->
    <div class="row align-items-center pt-8 w-100">
      <div class="col-10 text-end"></div>
      <div class="col-2 quote-container d-flex align-items-center">
        <v-form-input
          id="remaining-amount"
          :label="$t('general.shared.remainingAmount')"
          autocomplete="off"
          form-type="outline"
          type="text"
          class="disabled-input"
          disabled
          v-model="tourRemainingAmount"
        />
      </div>
    </div>
    <template v-if="showFlightsInvoice">
      <hr />
      <div class="row align-items-center pt-12 w-100">
        <div class="col-2">Total Flight</div>
        <div class="col-10 d-flex justify-content-end total-price-container">
          <v-pricing-update
            :id="`tour-flight-${tourId}`"
            :gross="flightgrossPrice"
            :markup="flightmarkupPrice"
            :net="flightnetPrice"
            :agency="agency"
            :case-id="Number(caseId)"
            :tour-id="Number(tourId)"
            class="is-mobile"
            is-flight
            is-group-type
            is-invoice
            is-new-version
            @updated-total-type-pricing="onUpdatedTotalTypePricing($event, 'plane')"
            @update-total-pricing="onUpdateTotalPricing"
            @load-tour-pricing="onLoadTourPricing"
          />
        </div>
      </div>
      <div
        class="row align-items-center pt-12 w-100"
        v-for="item in invoiceListData.filter((e) => e.type === 'emitted_flight')"
        :key="item.id"
      >
        <template v-for="subItem in item.invoice_lines" :key="subItem.id">
          <!-- Invoice Field -->
          <div class="col-2">
            <div class="button-container">
              <span class="button-label">{{ $t("general.shared.invoice") }}</span>
              <button class="custom-button" :id="`invoice-${subItem.id}`" @click="navigateToInvoicePage(item.id)">
                <v-icon icon="pdf" size="sm" space="p-12" />
                {{ item.number }}
              </button>
            </div>
          </div>

          <!-- Concept Field -->
          <div class="col-8 d-flex justify-content-end total-price-container">
            <v-form-input
              :id="`concept-${subItem.id}`"
              class="w-100 disabled-input"
              :label="$t('general.shared.concept')"
              autocomplete="off"
              form-type="outline"
              input-type="textarea"
              type="text"
              disabled
              v-model="subItem.description"
            />
          </div>

          <!-- Amount Field -->
          <div class="col-2 quote-container d-flex align-items-center">
            <v-form-input
              :id="`amount-${subItem.id}`"
              :label="$t('general.shared.amount')"
              autocomplete="off"
              form-type="outline"
              type="text"
              class="disabled-input"
              disabled
              v-model="subItem.amount"
            />
          </div>
        </template>
      </div>
      <!-- Remaining Amount -->
      <div class="row align-items-center pt-8 mb-24 w-100">
        <div class="col-10 text-end"></div>
        <div class="col-2 quote-container d-flex align-items-center">
          <v-form-input
            id="remaining-amount"
            :label="$t('general.shared.remainingAmount')"
            autocomplete="off"
            form-type="outline"
            type="text"
            v-model="flightRemainingAmount"
            disabled
            class="disabled-input"
          />
        </div>
      </div>
    </template>
  </div>
  <the-custom-notes-off-canvas
    v-if="offCanvasToShow === 'the-custom-notes-off-canvas'"
    :agency="agency"
    :case-id="Number(caseId)"
    :tour-id="Number(tourId)"
    type="invoice"
    :invoice-notes="invoiceAmount.custom_notes"
    @closed="closeOffCanvas()"
    @reload-items="onLoadTourPricing"
    @invoice-list="emitInvoiceList()"
  />
</template>

<script>
import { VFormInput } from "@uniqoders/form";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import VPricingUpdate from "@/components/pricing/VPricingUpdate.vue";
import TheLock from "@/assets/icons/TheLock.vue";
import TheUnLock from "@/assets/icons/TheUnLock.vue";
import { useUserStore } from "@/stores/user";
import { mapState } from "pinia";
import TheCustomNotesOffCanvas from "@/components/notes/TheCustomNotesOffCanvas.vue";
import useOffCanvasUtils from "@/helpers/OffCanvasUtils";

export default {
  name: "TheTourPricingBilling",
  components: {
    VPricingUpdate,
    VFormInput,
    VButton,
    VIcon,
    TheLock,
    TheUnLock,
    TheCustomNotesOffCanvas,
  },
  emits: [
    "loadTourPricing",
    "updateTotalPricing",
    "update:gross",
    "update:markup",
    "update:net",
    "update:quote",
    "updateQuotePrice",
    "toggleLock",
    "openOffCanvas",
    "invoiceList",
  ],
  setup() {
    return {
      ...useOffCanvasUtils(),
    };
  },
  props: {
    agency: {
      type: String,
      required: true,
    },
    caseId: {
      type: Number,
      required: true,
    },
    tourId: {
      type: Number,
      required: true,
    },
    isTotal: {
      type: Boolean,
      required: false,
      default: false,
    },
    net: {
      type: Number,
      required: true,
    },
    markup: {
      type: Number,
      required: true,
    },
    gross: {
      type: Number,
      required: true,
    },
    quote: {
      type: Number,
      required: true,
    },
    lock: {
      type: Boolean,
      required: false,
      default: false,
    },
    invoiceListData: {
      type: Array,
      required: false,
      default: () => [],
    },
    invoiceAmount: {
      type: Object,
      required: false,
      default: () => null,
    },
    isNewVersion: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      localQuotePrice: this.quote,
      tourRemainingAmount: this.invoiceAmount?.tour?.total_remaining,
      flightgrossPrice: this.invoiceAmount?.flights?.flights_gross,
      flightnetPrice: this.invoiceAmount?.flights?.flights_net,
      flightmarkupPrice: this.invoiceAmount?.flights?.flights_markup,
      flightRemainingAmount: this.invoiceAmount?.flights?.total_remaining,
      openedWindowPreview: null,
    };
  },
  watch: {
    quote(newValue) {
      this.localQuotePrice = newValue;
    },
    invoiceAmount(newValue) {
      this.tourRemainingAmount = newValue?.tour?.total_remaining;
      this.flightgrossPrice = newValue?.flights?.flights_gross;
      this.flightnetPrice = newValue?.flights?.flights_net;
      this.flightmarkupPrice = newValue?.flights?.flights_markup;
      this.flightRemainingAmount = newValue?.flights?.total_remaining;
    },
  },
  computed: {
    ...mapState(useUserStore, ["currentTour"]),
    showFlightsInvoice() {
      return this.invoiceListData?.filter((e) => e.type === "emitted_flight").length > 0;
    },
  },
  methods: {
    onUpdatedTotalTypePricing(response, type) {
      this.$emit("updatedTotalTypePricing", response, type);
      this.$emit("invoiceList");
    },
    onUpdateTotalPricing(data) {
      this.$emit("updateTotalPricing", data);
    },
    onLoadTourPricing() {
      this.$emit("loadTourPricing");
    },
    emitUpdateQuotePrice(source) {
      this.$emit("update:quote", this.localQuotePrice);
      this.$emit("updateQuotePrice", source);
      this.$emit("invoiceList");
    },
    toggleLock() {
      this.$emit("toggleLock");
    },
    openBillingOffCanvas() {
      this.$emit("openOffCanvas");
    },
    openCustomNotesModal() {
      this.openOffCanvas("the-custom-notes-off-canvas");
    },
    emitInvoiceList() {
      this.$emit("invoiceList");
    },
    navigateToInvoicePage(invoiceNumber) {
      if (!!this.openedWindowPreview && !this.openedWindowPreview.closed) {
        this.openedWindowPreview.close();
      }
      const routeData = this.$router.resolve({
        name: "tour.invoice.invoice",
        params: { caseId: this.caseId, tourId: this.tourId, invoice: invoiceNumber },
        query: {
          token: this.currentTour?.token,
          locale: !!localStorage.getItem("language")
            ? localStorage.getItem("language")
            : !!import.meta.env.VITE_APP_DEFAULT_LOCALE
            ? import.meta.env.VITE_APP_DEFAULT_LOCALE
            : !!import.meta.env.VITE_APP_DEFAULT_LOCALE
            ? import.meta.env.VITE_APP_DEFAULT_LOCALE
            : "en",
          summary: 1,
        },
      });
      const width = 1100;
      const height = 800;
      const top = window.top.outerHeight / 2 + window.top.screenY - height / 2;
      const left = window.top.outerWidth / 2 + window.top.screenX - width / 2;

      this.openedWindowPreview = window.open(
        routeData.href,
        "_blank",
        `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=${left},width=${width},height=${height},top=${top}`
      );
    },
  },
};
</script>

<style scoped lang="scss">
.resource-header {
  cursor: pointer;
  margin-bottom: 24px;
}

.billing-section {
  border: 1px solid var(--uq-gray-400);
  border-radius: 0.25rem;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  .total-price-container {
    .is-mobile {
      width: 100% !important;
    }
  }

  .quote-container {
    display: flex;
    align-items: center;

    .lock-btn {
      margin-left: 0.5rem;
      align-self: center;
    }

    @media screen and (max-width: 992px) {
      flex-direction: column;
      align-items: flex-start;

      .lock-btn {
        margin-top: 8px;
        align-self: flex-end;
      }
    }
  }

  .disabled-input {
    :deep(.form-control) {
      background-color: #f7f7fc !important;
      border: 0.0625rem solid #d5d5d5 !important;
      color: black;
      line-height: 25px !important;
    }
  }
}

.custom-button {
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  font-size: 16px;
  background-color: #f7f7fc;
  border: 1px solid #ddd;
  border-radius: 8px;
  color: black;
  text-align: left;
  border-radius: 0.25rem;
  padding: 0.45rem;
  min-height: 3.0625rem;
}
.custom-button:hover {
  background-color: #e5e1e1;
}
.button-label {
  color: #666;
  position: absolute;
  transform: translateY(-12px);
  background: white;
  padding: 0 5px;
  margin-left: 16px;
}
.button-container {
  position: relative;
  display: inline-block;
  width: 100%;
  padding-top: 20px;
}

.cutom-notes {
  background-color: #32de84;
  border-color: #32de84;
}

.cutom-notes:hover {
  background-color: #32de84;
  border-color: #32de84;
}
</style>
